module.exports = __webpack_public_path__ + "img/cover-promotion-bg.df98d82e.png";